import { useRowSelect } from '@table-library/react-table-library/select';
import { Action, State } from '@table-library/react-table-library/types/common';
import { useNavigate } from 'react-router-dom';
import { INodes } from 'services/types';

export interface ISelectableTable {
  customPath?: (id: string) => string;
  selectable?: boolean;
}

export const useSelectTable = <T extends { id: string | number }>(
  data: INodes<T>,
  options: ISelectableTable = { selectable: true }
) => {
  const navigate = useNavigate();

  const onSelectChange = (action: Action, state: State) => {
    const id: string = state.id ?? state.ids[state.ids.length - 1];
    navigate(options?.customPath ? options.customPath(id) : id);
  };

  const select = useRowSelect(data, {
    onChange: onSelectChange,
  });

  return options?.selectable ? select : undefined;
};
